import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseComponent.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

const TableChooseUe_ = (props) => {
    const map = useMapContext()
    const {prjTypeCode, subTypeCode} = map.data

    const columnModule = (() => {
        if (
            'BM' === prjTypeCode ||
            'BODA2' === subTypeCode
        ) {
            return {
                title: '业务域',
                dataIndex: 'bmNamePath',
                component: <Table.ViewText />,
            }
        }
        else {
            return {
                title: '功能域',
                dataIndex: 'fmNamePath',
                component: <Table.ViewText />,
            }
        }
    })()

    const columns = [
        'BCT' === map.data.prjTypeCode && {
            title: '界面方案',
            dataIndex: 'uiCase',
            component: <Table.ViewText />,
        },

        columnModule,

        {
            title: '子系统',
            dataIndex: 'ssName',
            component: <Table.ViewText />,
        },

        {
            title: '界面名称',
            dataIndex: 'uiName',
            component: <Table.ViewText />,
        },

        {
            title: '界面代码',
            dataIndex: 'uiUserCode',
            component: <Table.ViewText />,
        },

        {
            title: '能力标题',
            dataIndex: 'algTitle',
            getValue: ({algTitle, ueName}) => algTitle ?? ueName,
        },

        {
            title: '能力代码',
            component: <Table.ViewText />,
            getValue: ({algUserCode, ueUserCode}) => algUserCode ?? ueUserCode,
        },

        {
            title: '能力类型',
            dataIndex: 'algType',
            component: <Table.ViewDict dict={{GENERAL: '基础', UE: '事件'}} />,
        },
    ].filter(a => a)

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseUe_
